import React from "react";
import "./skins.css";

function buildPreview({
  item,
  latestEvent,
  latestPayload,
  latestReceivedAt,
  controls = [],
  rules = [],
  commandStatus,
}) {
  return {
    item: {
      id: item?.id ?? null,
      name: item?.name ?? null,
      device_number: item?.device_number ?? null,
      category: item?.category ?? null,
      status: item?.status ?? null,
      status_label: item?.status_label ?? null,
    },
    event: latestEvent
      ? {
          id: latestEvent.id ?? null,
          topic: latestEvent.topic ?? null,
          payload: latestPayload ?? latestEvent.payload ?? null,
          received_at: latestReceivedAt ?? latestEvent.received_at ?? null,
        }
      : null,
    controls,
    rules,
    command_status: commandStatus || null,
  };
}

export default function JsonViewerSkin(props) {
  const preview = buildPreview(props);

  return (
    <section className="json-viewer-skin">
      <header className="json-viewer-skin__header">
        <div>
          <h3>{props.item?.name || "항목"}</h3>
          <span>{props.item?.panel_label || props.item?.category || "미분류"} {props.item?.device_number || ""}</span>
        </div>
        <strong>JSON</strong>
      </header>
      <div className="json-viewer-skin__body">
        <pre>{JSON.stringify(preview, null, 2)}</pre>
      </div>
    </section>
  );
}
